import { render, staticRenderFns } from "./ManagementSim.vue?vue&type=template&id=6be12684&scoped=true"
import script from "./ManagementSim.vue?vue&type=script&lang=js"
export * from "./ManagementSim.vue?vue&type=script&lang=js"
import style0 from "./ManagementSim.vue?vue&type=style&index=0&id=6be12684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be12684",
  null
  
)

export default component.exports